const CloseWindow = () => {
    window.close();
    return (null);
  };
  
  export default CloseWindow;